// import React, { useState } from 'react';
// import { FormControl, InputLabel, Select, MenuItem, OutlinedInput, Chip } from '@mui/material';

// const MultiSelect = ({ options, label, onChange }) => {
//   const [selectedItems, setSelectedItems] = useState([]);

//   const handleChange = (event) => {
//     const {
//       target: { value },
//     } = event;
//     const selected = typeof value === 'string' ? value.split(',') : value;
//     setSelectedItems(selected);
//     if (onChange) onChange(selected); // Callback to parent component if needed
//   };

//   return (
//     <FormControl fullWidth>
//       <InputLabel id={`${label}-label`}>{label}</InputLabel>
//       <Select
//         labelId={`${label}-label`}
//         id={`${label}-select`}
//         multiple
//         value={selectedItems}
//         onChange={handleChange}
//         input={<OutlinedInput id={`${label}-multiple-chip`} label={label} />}
//         renderValue={(selected) => (
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//             {selected.map((value) => (
//               <Chip key={value} label={options.find((option) => option.value === value)?.label || value} />
//             ))}
//           </div>
//         )}
//       >
//         {options.map((option) => (
//           <MenuItem key={option.value} value={option.value}>
//             {option.label}
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   );
// };

// export default MultiSelect;


// import React, { useState } from 'react';
// import { FormControl, InputLabel, Select, MenuItem, OutlinedInput, Chip } from '@mui/material';

// const MultiSelect = ({ options, label, onChange,  e, multiple = true }) => {
//   const [selectedItems, setSelectedItems] = useState([]);

//   const handleChange = (event) => {
//     let value = event.target.value;
//     // If multiple is false (single select), ensure value is an array with only the last selected item
//     if (!multiple) {
//       value = [value[value.length - 1]]; // This ensures that value is always an array, even for single selection
//     }
//     setSelectedItems(value);
//     if (onChange) onChange(value);
//   };

//   return (
//     <FormControl fullWidth disabled={disabled}>
//       <InputLabel id={`${label}-label`}>{label}</InputLabel>
//       <Select
//         labelId={`${label}-label`}
//         id={`${label}-select`}
//         multiple={multiple} // Control multiple selection based on the prop
//         value={selectedItems}
//         onChange={handleChange}
//         input={<OutlinedInput id={`${label}-multiple-chip`} label={label} />}
//         renderValue={(selected) => multiple ? (
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//             {selected.map((value) => (
//               <Chip key={value} label={options.find((option) => option.value === value)?.label || value} />
//             ))}
//           </div>
//         ) : undefined} // For single select, the default renderValue is used
//       >
//         {options.map((option) => (
//           <MenuItem key={option.value} value={option.value}>
//             {option.label}
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   );
// };

// export default MultiSelect;

import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, OutlinedInput, Chip } from '@mui/material';

const MultiSelect = ({ options, label, multiple = false, onChange, value: externalValue, disabled = false }) => {
  // Determine if the component is controlled
  const isControlled = externalValue !== undefined;
  // Initialize internal state for uncontrolled component
  const [internalValue, setInternalValue] = useState(multiple ? [] : '');

  // Use externalValue if controlled, otherwise use internal state
  const value = isControlled ? externalValue : internalValue;

  const handleChange = (event) => {
    const newValue = event.target.value;
    // Update internal state if uncontrolled
    if (!isControlled) {
      setInternalValue(newValue);
    }
    // Call onChange prop with new value
    onChange?.(newValue);
  };

  // Adjust how value is passed to Select based on multiple prop
  const selectValue = multiple ? value : value[0] ;

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple={multiple}
        value={selectValue}
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        renderValue={selected => multiple ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((val) => (
              <Chip key={val} label={options.find(option => option.value === val)?.label || val} />
            ))}
          </div>
        ) : undefined} // No custom renderValue needed for single select
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelect;
